/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { Button } from '@zcode-ui/controls'
import { selectIsBot } from '@zcode-ui/web-zumper-global-state'
import { RENT_REPORT_IMPRESSION } from '@zcode-ui/web-zumper-integrations'
import { buildSrc } from '@zcode/image-cdn-utils'
import { HOMEPAGE } from '@zcode/mixpanel'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { selectHashtagModalRentReport } from '../../../modules/modals/selectors/hashtagModal'
import { RentReportComponent } from '../../HashtagModal/RentReportComponent'
import { useHomepageImpression } from '../hooks/useHomepageImpression'
import rentReportImage from './img/rentreport.webp'

const NationalRentReport = () => {
  const isBot = useSelector(selectIsBot)
  const rentReport = useSelector(selectHashtagModalRentReport)
  const ref = useHomepageImpression({
    name: RENT_REPORT_IMPRESSION,
    mixpanelSection: HOMEPAGE.RENT_REPORT,
  })

  return (
    <>
      <div className="flex flex-col md:flex-row gap-10 xl:gap-6 items-center" ref={ref}>
        <div className="flex flex-col lg:px-8 xl:px-12 w-full">
          <h2 className="mb-4 display28To32">Zumper National Rent Report</h2>
          <p className="body16Reg text-gray-950 lg:w-full xl:w-[492px]">
            We analyze over one million active listings across the country to inform our monthly
            rent report. Get a comprehensive view of the current state of the market.
          </p>
          <Button as={Link} className="mt-10 w-fit" size="md" to="#rent-report" variant="outline">
            View latest report
          </Button>
        </div>
        <img
          alt=""
          className="h-[247px] md:h-[203px] lg:h-[286px] xl:h-[388px] rounded-3xl shrink-0 w-[375px] md:w-[308px] lg:w-[434px] xl:w-[588px]"
          loading="eager"
          src={buildSrc(rentReportImage, {
            fit: 'clip',
            h: 400,
            w: 588,
          })}
        />
      </div>
      {isBot && rentReport && (
        <div className="hidden">
          {' '}
          <RentReportComponent rentReport={rentReport} />
        </div>
      )}
    </>
  )
}

export default NationalRentReport
